import { render, staticRenderFns } from "./navbar-auth.vue?vue&type=template&id=70554c52&scoped=true&"
import script from "./navbar-auth.vue?vue&type=script&lang=js&"
export * from "./navbar-auth.vue?vue&type=script&lang=js&"
import style0 from "./navbar-auth.vue?vue&type=style&index=0&id=70554c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70554c52",
  null
  
)

export default component.exports